import { render, staticRenderFns } from "./product-reviews-options.vue?vue&type=template&id=724b2fc2&scoped=true&"
import script from "./product-reviews-options.vue?vue&type=script&lang=js&"
export * from "./product-reviews-options.vue?vue&type=script&lang=js&"
import style0 from "./product-reviews-options.vue?vue&type=style&index=0&id=724b2fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b2fc2",
  null
  
)

export default component.exports